import React from 'react';
import { useFormik as useFormikOriginal } from 'formik';

export const useFormik = (props) => {
  const [submitted, setSubmitted] = React.useState(false);

  const formik = useFormikOriginal({
    ...props,
    validateOnChange: submitted,
    validateOnBlur: submitted,
  });

  React.useEffect(() => {
    if (formik.submitCount > 0) {
      setSubmitted(true);
    }
  }, [formik.submitCount]);

  return formik;
};
